export const BvBannerDiscountProps = {
  cardClass:
    'border-radius-6 items-center bg-surface-green border-border-green q-mb-lg',
  contentClass: 'text-marketing-default items-center font-12 w-400 q-mb-none',
  iconSrc: 'img:/questionnaire/icons/badge-check.svg',
  iconSep: 8
};
